<template>
  <div class="partition">
    <div class="topic" v-if="!createFlag">
      <div class="topic_top">
        <div class="uploadPage_toptitle">
          <div class="uploadPage_toptitlebox">
            <van-icon
              class="uploadPage_back"
              name="arrow-left"
              @click="backClick"
            />
            <div class="uploadPage_title">选择版块</div>
            <span v-show="this.$store.state.system !== 'android'"></span>
            <van-icon
              class="fork"
              name="close"
              v-show="
                this.$store.state.system == 'android' &&
                applets != 'xcx' &&
                !$store.state.isXcx &&
                this.$store.state.isInGame
              "
              @click="closeCommunity"
            />
          </div>
        </div>
      </div>
      <div class="topic_contentbox">
        <van-pull-refresh
          v-model="refreshing"
          success-text="刷新成功"
          @refresh="onRefresh"
        >
          <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            :offset="10"
            @load="onLoad"
          >
            <div class="commonBg"></div>
            <div
              class="topic_content"
              v-for="item in contentList"
              :key="item.id"
              @click="selectPartition(item)"
            >
              <div class="topic_content_portrait" :class="item.head">
                <!-- <img v-if="!item.logo" src="//media.zlongame.com/media/pictures/cn/community/1705460260139/avatar/1.png" alt=""> -->
                <!-- <img v-else :src="item.logo" alt=""> -->
                  <img  :src="item.logo" alt="">
              </div>
              <div class="topic_content_text">
                <div class="topic_content_text_title">
                  <!-- <span></span> -->
                  <div class="topic_content_text_top">
                    {{ item.partitionName }}
                  </div>
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <create
      v-if="createFlag"
      @goCreate="goCreate"
      @addClick="addClick"
    ></create>
  </div>
</template>
<script>
import create from "./create.vue";
import { Toast } from "vant";
import _ from "lodash";
import qs from "qs";
import get from "../../../api/get";
import * as _code from "../../../utils/code";
import arrNewSet from '@/utils/arrNewSet';
export default {
  name: "topic",
  components: { create },
  data() {
    return {
      applets: window.user.weixcode ? "xcx" : "",
      brush: true,
      finished: false,
      refreshing: false,
      loading: false,
      createFlag: false,
      nextPage: true,
      nextNum: 0,
      pageId: 1,
      subId: 0,
      onsubId: 2,
      titleList: [
        { id: 0, name: "最近使用", class: "", underline: "under", subId: 0 },
        {
          id: 1,
          name: "话题",
          class: "cur",
          underline: "underline",
          subId: 0,//2：热门 4:英雄 0:全部
        },
        // { id: 2, name: "龙晶", class: "", underline: "under", subId: 4 },
      ],
      contentList: [],
      allContentList: {},
      recentlyList: [
        { id: 0, head: "topic_content_hot", subjectName: "最近使用" },
        { id: 1, head: "topic_content_hot", subjectName: "最近使用" },
        { id: 2, head: "topic_content_hot", subjectName: "最近使用" },
      ],
    };
  },
  mounted() {
    // this.init(2);
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.onLoad();
  },
  methods: {
    selectPartition(item){
      this.$emit("selectPartition", item);
    },
    onLoad() {
      this.loading = true;
      setTimeout(() => {
        this.init(
          this.subId,
          () => {
            this.loading = false;
          },
          "next"
        );
      }, 100);
    },
    //下拉加载
    onRefresh() {
      if (this.pageId == 0) {
        this.getRecordlyList(() => {
          this.refreshing = false;
          // Toast("刷新完成");
        });
      } else {
        this.nextNum = 1;
        this.init(this.subId, () => {
          this.refreshing = false;
          // Toast("刷新完成");
        });
      }
    },
    init(id, fun, next) {
      if (next == "next") {
        this.nextNum++;
      }
      if (id != this.onsubId) {
        this.nextNum = 1;
      }
      this.onsubId = id;
      let _obj = {
        type: id,
        pageNo: this.nextNum,
        pageSize: 10,
      };
      get.partitionList(_obj).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          if (fun) {
            fun();
          }
          if (this.nextNum == 1) {
            // this.contentList = data.data;
            data.data.forEach((item, index) => {
              if(item.canUse == 1){//0不可以,1全部可以,2管理员可以
                this.contentList.push(item);
                this.contentList = arrNewSet(this.contentList);
              }
            });
          } else {
            data.data.forEach((item, index) => {
              if(item.canUse == 1){
                this.contentList.push(item);
              }
            });
          }
          console.log("data.data.length", data.data.length);
          if (data.data.length == 10) {
            this.nextPage = true;
          } else {
            this.nextPage = false;
            this.finished = true;
          }
        } else {
          this.errorMessage(data);
        }
      });
    },
    getRecordlyList(fun) {
      get.recordlyList().then((res) => {
        let data = res.data;
        if (data.code == 0) {
          this.nextPage = false;
          this.contentList = data.data;
          if (fun) {
            fun();
          }
        } else {
          this.errorMessage(data);
        }
      });
    },
    addClick(item) {
      if (this.brush) {
        this.brush = false;
        this.$emit("addmyTopic", item, () => {
          this.backClick();
          this.brush = true;
        });
      }
    },
    goCreate(flag) {
      this.createFlag = flag;
    },
    contentChang(id, subId) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.pageId = id;
      this.subId = subId;
      this.titleList.forEach((item, index) => {
        item.class = "";
        item.underline = "under";
      });
      this.titleList[id].class = "cur";
      this.titleList[id].underline = "underline";
      this.contentList = [];
      switch (id) {
        case 0:
          this.getRecordlyList();
          break;
        case 1:
          this.init(0);
          break;
        case 2:
          this.init(4);
          break;
        default:
          break;
      }
    },
    addcontentList(item) {
      this.$emit("addmyTopic", item);
    },
    backClick() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$emit("gotopic", false);
    },
    closeCommunity() {
      window.pd.onBBSClose();
    },
    //错误提示
    errorMessage(data) {
      let code = data.code;
      if (code != 2050) {
        let voteErr = _code.code.vote;
        let msg = voteErr[code] ? voteErr[code] : voteErr["other"] + code;
        Toast(msg);
      }
    },
  },
};
</script>
<style lang='scss' scoped>
</style>